import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // Ensure this line is correct
import 'bulma/css/bulma.css';
import '@fortawesome/fontawesome-free/css/all.css';
//import axios from 'axios';

//axios.defaults.baseURL = 'http://localhost:8000';
//____
const app = createApp(App);
app.use(store);
app.use(router);
app.mount('#app');
